import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import Usuario from 'Interface/Usuarios';

interface Autenticacao {
    usuario?: Usuario;
    token?: string;
    message?: string;
}

const inicial: Autenticacao = {};

export const autenticacao = createSlice({
    name: 'autenticacao',
    initialState: inicial,
    reducers: {
        login: (estado, acao: PayloadAction<Autenticacao>) => estado = acao.payload,
        logout: () => inicial,
    }
});

export const { login, logout } = autenticacao.actions;

export default autenticacao.reducer;
